module.exports = __webpack_public_path__ + "static/poster-about-page-1387a3f06118005a101336e3b3df8973.jpeg";